import {
	UniversitiesFilterOptions,
	UniversitySearchPayload,
} from '../models/university-search.models';

/**
 * @param filters from store location selected by user
 * @param payload from store
 * @returns filter options with checked values based on what IDs have been sent to the BE & stored in the payload
 */
export const updateLocationFilter = (
	filters: UniversitiesFilterOptions,
	payload: UniversitySearchPayload,
): UniversitiesFilterOptions => {
	const filtersCopy = structuredClone(filters);

	const options = filtersCopy.locations;

	const selectedOptionIds = payload.locationIds;
	options.forEach((option) => {
		option.checked = selectedOptionIds?.includes(option.id) ?? false;
	});

	return filtersCopy;
};
